async function fetchPDFs() {
    const lotNumber = document.getElementById('pdfId').value.trim();
    const errorMessage = document.getElementById('errorMessage');
    const successMessage = document.getElementById('successMessage');
    const pdfContainerDesktop = document.getElementById('pdfContainerDesktop');
    const pdfContainerMobile = document.getElementById('pdfContainerMobile');
    const pdfListContainer = document.getElementById('pdfListContainer'); // Unified list container

    // Clear previous results
    pdfContainerDesktop.innerHTML = "";
    pdfContainerMobile.innerHTML = "";
    pdfListContainer.innerHTML = "";
    errorMessage.classList.add('m:hidden');
    successMessage.classList.add('m:hidden');

    if (!lotNumber) {
        errorMessage.textContent = "Please enter a Lot Number.";
        errorMessage.classList.remove('m:hidden');
        return;
    }

    // StoreFront GraphQL Query
    const query = `
        query {
            metaobjects(type: "medication_report", first: 250) {
                edges {
                    node {
                        fields {
                            key
                            value
                        }
                    }
                }
            }
        }
    `;

    try {
        const response = await fetch('https://viking-nutrition-store.myshopify.com/api/2023-10/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'e155b29bde06309744786300b758b8f6'
            },
            body: JSON.stringify({ query })
        });

        const data = await response.json();
        const metaobjects = data?.data?.metaobjects?.edges || [];

        // Find the metaobject matching the lot_number
        const matchedEntry = metaobjects.find(entry => 
            entry.node.fields.some(f => f.key === "lot_number" && f.value === lotNumber)
        );

        if (!matchedEntry) {
            errorMessage.textContent = "No matching lot number found.";
            errorMessage.classList.remove('m:hidden');
            return;
        }

        // Extract file GIDs
        const pdfField = matchedEntry.node.fields.find(f => f.key === "pdf_files");
        const fileGids = pdfField ? JSON.parse(pdfField.value) : [];

        if (fileGids.length === 0) {
            errorMessage.textContent = "No files found.";
            errorMessage.classList.remove('m:hidden');
            return;
        }

        // Fetch all file URLs in one GraphQL request
        const fileQuery = `
        query {
            nodes(ids: ${JSON.stringify(fileGids)}) {
                ... on GenericFile {
                    url
                }
                ... on MediaImage {
                    image {
                        url
                    }
                }
            }
        }
        `;

        const fileResponse = await fetch('https://viking-nutrition-store.myshopify.com/api/2023-10/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'e155b29bde06309744786300b758b8f6'
            },
            body: JSON.stringify({ query: fileQuery })
        });

        const fileData = await fileResponse.json();

        // Extract valid file URLs and derive filenames
        const fileEntries = fileData?.data?.nodes
            .map(node => ({
                url: node?.url || node?.image?.url,
                name: node?.url ? node.url.split('/').pop().split('?')[0] : "PDF File"
            }))
            .filter(entry => entry.url !== undefined);

        if (fileEntries.length === 0) {
            errorMessage.textContent = "No valid PDFs found.";
            errorMessage.classList.remove('m:hidden');
            return;
        }

        // Display results
        successMessage.innerHTML = `<h3 class="m:text-center">Result for #${lotNumber}</h3>`;
        successMessage.classList.remove('m:hidden');

        if (fileEntries.length === 1) {
            const pdfUrl = fileEntries[0].url;
            
            // **Desktop: Show PDF in iframe**
            const iframe = document.createElement('iframe');
            iframe.src = pdfUrl;
            iframe.style = "width: 100%; height: 600px; border: none;";
            pdfContainerDesktop.appendChild(iframe);

            // **Mobile: Render PDF using pdf.js + Download Link**
            displayPDFMobile(pdfUrl, pdfContainerMobile);
        } else {
            // **Multiple PDFs: Show a clickable list in a single container**
            const list = document.createElement('ul');
            list.classList.add('pdf-list');

            fileEntries.forEach(entry => {
                const listItem = document.createElement('li');

                const link = document.createElement('a');
                link.href = entry.url;
                link.textContent = entry.name;
                link.target = "_blank";

                listItem.appendChild(link);
                list.appendChild(listItem);
            });

            pdfListContainer.appendChild(list); // List goes to unified container
        }
    } catch (error) {
        errorMessage.textContent = error.message;
        errorMessage.classList.remove('m:hidden');
    }
}

// **Function to render PDF for mobile using pdf.js**
async function displayPDFMobile(url, container) {
    container.innerHTML = ""; // Clear previous content

    // **Download button**
    const downloadBtn = document.createElement("a");
    downloadBtn.href = url;
    downloadBtn.classList.add('pdf-file-download');
    downloadBtn.target = "_blank";
    downloadBtn.download = url.split('/').pop();
    downloadBtn.textContent = "Download PDF";
    container.appendChild(downloadBtn);

    // **Render PDF**
    const loadingTask = pdfjsLib.getDocument(url);
    const pdf = await loadingTask.promise;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const scale = 1.5;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.style = "width: 100%; display: block; margin-bottom: 10px;";

        const context = canvas.getContext("2d");
        const renderContext = { canvasContext: context, viewport };
        await page.render(renderContext).promise;

        container.appendChild(canvas);
    }
}

// **Listen for Enter key**
document.getElementById('pdfId').addEventListener('keyup', (event) => {
    if (event.key === "Enter") {
        fetchPDFs();
    }
});